import { Component, Input } from '@angular/core';

export interface ContactDetailsConfig {
  hours?: string;
  days?: string;
  phone1?: string;
  phone2?: string;
  slack?: string;
  email?: string;
}

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
})
export class ContactDetailsComponent {
  @Input() config!: ContactDetailsConfig;

  get hours() {
    return this.config.hours;
  }

  get days() {
    return this.config.days;
  }

  get phone1() {
    return this.config.phone1;
  }

  get phone2() {
    return this.config.phone2;
  }

  get slack() {
    return this.config.slack;
  }

  get email() {
    return this.config.email;
  }
}
